import React from 'react';
import { useRouterState } from '@tanstack/react-router';

import { useCompanyQuerystringParams } from './useCompanyQuerystringParams';
import { CompanyIdProvider } from './CompanyIdProvider';

export type CompanyIdFromRouteProviderProps = {
  children: React.ReactNode;
};

export const CompanyIdFromRouteProvider = (
  props: CompanyIdFromRouteProviderProps
) => {
  const companyQuerystringParams = useCompanyQuerystringParams();
  const pathname = useRouterState({
    select: (state) => {
      return state.location.pathname;
    },
  });

  const isMateOrMarktingLandingPageRoute = [
    '/',
    '/m/mate',
    '/m/mate-verify',
    '/registernew/AU',
    '/registernew/NZ',
  ].includes(pathname);

  return (
    (isMateOrMarktingLandingPageRoute && <>{props.children}</>) || (
      <CompanyIdProvider companyId={companyQuerystringParams.companyId}>
        {props.children}
      </CompanyIdProvider>
    )
  );
};
